var render, staticRenderFns
import script from "./pictureGroup.vue?vue&type=script&lang=js"
export * from "./pictureGroup.vue?vue&type=script&lang=js"
import style0 from "./pictureGroup.vue?vue&type=style&index=0&id=1c22946e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c22946e",
  null
  
)

export default component.exports